import type { FC } from 'react';

export const HyperspellLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/hyperspell-logo.png"
      alt="Hyperspell"
      className="w-full h-full object-contain"
    />
  </div>
);
